var exports = {
  "kL": "VoiceMessagePlayer.module__container___TXktam",
  "Kd": "VoiceMessagePlayer.module__containerActive___TXktam",
  "hd": "VoiceMessagePlayer.module__waveformBar___TXktam",
  "x5": "VoiceMessagePlayer.module__waveformBarPast___TXktam",
  "Rr": "VoiceMessagePlayer.module__playButton___TXktam",
  "CJ": "VoiceMessagePlayer.module__playButtonIcon___TXktam",
  "S": "VoiceMessagePlayer.module__loadingSpinner___TXktam",
  "t0": "VoiceMessagePlayer.module__spin___TXktam",
  "FU": "VoiceMessagePlayer.module__waveformContainer___TXktam",
  "vE": "VoiceMessagePlayer.module__timestamp___TXktam",
  "NS": "VoiceMessagePlayer.module__speedControl___TXktam",
  "Wq": "VoiceMessagePlayer.module__volumeControl___TXktam",
};

module.exports = exports;
